
class Navigation {
    constructor() {
        this.dropdowns = document.querySelectorAll('.nav__dropdown');
        this.mobilenav = document.querySelector('.nav-mobile');
        this.hamburger = document.querySelector('.nav__burger');
        this.navclose = document.querySelector('.nav-mobile__close');
        this.links = document.querySelectorAll('.nav__item > a');

        this.events();
        this.addHighlight();
    }

    events() {
        this.dropdowns.forEach(dropdown => {
            dropdown.addEventListener('click', this.toggleDropdown.bind(this));
        });
        this.hamburger.addEventListener('click', () => this.mobilenav.classList.add('nav-mobile--active'));
        this.navclose.addEventListener('click', () => this.mobilenav.classList.remove('nav-mobile--active'));
        document.body.addEventListener('click', this.closeDropdown.bind(this));
    }

    toggleDropdown(e) {
        this.dropdowns.forEach(dropdown => {
            if (dropdown !== e.target.closest('.nav__dropdown')) {
                dropdown.classList.remove('nav__dropdown--active');
            }
        });

        e.target.closest('.nav__dropdown').classList.toggle('nav__dropdown--active');
    }

    closeDropdown(e) {
        if(
            e.target.className?.match
            && e.target.className?.match(/nav\_\_*/)
        ) return;
        this.dropdowns.forEach(dropdown => {
            dropdown.classList.remove('nav__dropdown--active');
        })
    }

    addHighlight() {
        const loc = location.pathname;
        if(loc === '/' || loc === '') {
            return;
        }
        this.links.forEach(item => {
            if(item.href.indexOf(loc) > -1) {
                item.closest('.nav__item--top').classList.add('highlight');
            }
        });
    }
}

export default Navigation;
